import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorHandler, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HomeModule } from './home/home.module';
import { ScheduleModule } from './schedule/schedule.module';
import { AppointmentsModule } from './appointments/appointments.module';
import { NotFoundComponent } from './not-found/not-found.component';
import { CommonsUiModule } from './commons-ui/commons-ui.module';
import { ApiModule } from './api-client';
import { BASE_PATH } from './api-client/variables';
import { environment } from 'src/environments/environment';
import { AuthModule } from './auth/auth.module';
import { RequestHeadersInterceptor } from './api/request-headers-interceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserCacheLocation, IPublicClientApplication, InteractionType, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { ToastrModule } from 'ngx-toastr';
import { CommonsModule } from './commons/commons.module';
import { DatePipe } from '@angular/common';
import { SafeUrlPipe } from './commons/pipes/safe.pipe';

import { 

  MsalGuard, 

  MsalBroadcastService, 

  MsalInterceptorConfiguration, 

  MsalModule, 

  MsalService, 

  MSAL_GUARD_CONFIG, 

  MSAL_INSTANCE, 

  MSAL_INTERCEPTOR_CONFIG, 

  MsalGuardConfiguration, 

  MsalRedirectComponent 

} from '@azure/msal-angular';

import { AuthGuard } from './auth/auth-guard';

import { ApiErrorInterceptor } from './api/api-error-interceptor'; 

import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';

import { MbscModule } from '@mobiscroll/angular';

// MSAL Configs

export function MSALInstanceFactory(): IPublicClientApplication {

  return new PublicClientApplication({

    auth: {

      clientId: environment.authClientID,

      authority: environment.authAuthority,

      postLogoutRedirectUri: '/'

    },

    cache: {

      cacheLocation: BrowserCacheLocation.LocalStorage

    },

    system: {

      allowNativeBroker: false,

      loggerOptions: {

        logLevel: LogLevel.Info,

        piiLoggingEnabled: false

      }

    }

  });

}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {

  const protectedResourceMap = new Map<string, Array<string>>();

  protectedResourceMap.set(environment.baseApiUrl, ['user.read']);

  return {

    interactionType: InteractionType.Redirect,

    protectedResourceMap

  };

}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {

  return {

    interactionType: InteractionType.Redirect,

    authRequest: {

      scopes: ['user.read']

    },

    loginFailedRoute: '/login-failed'

  };

}

// Application Insights Factory (fixed)

export function appInsightsFactory() {
  const connectionString = environment.connectionString;

  const appInsights = new ApplicationInsights({

    config: {

      connectionString,

      enableAutoRouteTracking: true

    }

  });

  if (connectionString?.includes('InstrumentationKey=')) {
    appInsights.loadAppInsights();
  }

  return appInsights;

}

@NgModule({

  declarations: [

    AppComponent,

    HeaderComponent,

    FooterComponent,

    NotFoundComponent,

  ],

  imports: [

    MbscModule,

    FormsModule,

    BrowserModule,

    BrowserAnimationsModule,

    AppRoutingModule,

    HttpClientModule,

    ToastrModule.forRoot({}),

    AuthModule,

    ApiModule,

    MsalModule,

    CommonsUiModule,

    HomeModule,

    ScheduleModule,

    AppointmentsModule,

    CommonsModule,

    ReactiveFormsModule,

  ],

  providers: [

    AuthGuard,

    SafeUrlPipe,

    DatePipe,

    {

      provide: HTTP_INTERCEPTORS,

      useClass: RequestHeadersInterceptor,

      multi: true,

    },

    {

      provide: HTTP_INTERCEPTORS,

      useClass: ApiErrorInterceptor,

      multi: true,

    },

    {

      provide: MSAL_INSTANCE,

      useFactory: MSALInstanceFactory

    },

    {

      provide: MSAL_GUARD_CONFIG,

      useFactory: MSALGuardConfigFactory

    },

    {

      provide: MSAL_INTERCEPTOR_CONFIG,

      useFactory: MSALInterceptorConfigFactory

    },

    { provide: BASE_PATH, useValue: environment.baseApiUrl },

    MsalService,

    MsalGuard,

    MsalBroadcastService,

    {

      provide: ApplicationInsights,

      useFactory: appInsightsFactory

    },

    {

      provide: ErrorHandler,

      useClass: ApplicationinsightsAngularpluginErrorService

    }

  ],

  bootstrap: [AppComponent, MsalRedirectComponent]

})

export class AppModule { }

 